<p *ngIf="task.message.details.title">
  <strong>{{ task.message.details.title }}</strong>
</p>
<p *ngIf="task.message.content">
  <app-message-content [input]="task.message.content"></app-message-content>
</p>

<ng-container *ngFor="let attachment of task.message.attachments">
  <ng-container [ngSwitch]="attachment.mime_type">
    <ng-container *ngSwitchCase="'link'">
      <p>
        <ng-container *ngIf="attachment.is_valid; else invalidLink">
          <span class="attachment">
            <a href="{{ attachment.link }}" target="_blank" [translate]="'attachments/' + attachment.link_type"></a>
          </span>
        </ng-container>
        <ng-template #invalidLink>
          <span class="attachment invalid">
            <span [translate]="'attachments/invalid/' + attachment.link_type"></span>
          </span>
        </ng-template>
      </p>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="task.message.details.shopProductInfo">
  <p>
    <span class="attachment">
      <span class="name" translate="inbox/message/product"></span>
      <a [href]="task.message.details.shopProductInfo.productUrl" target="_blank">{{
        task.message.details.shopProductInfo.name
      }}</a>
      <span *ngIf="task.message.details.shopProductInfo.price">{{ task.message.details.shopProductInfo.price }}</span>
    </span>
  </p>
</ng-container>
<app-select-tags [tagsContext]="tagsContext"></app-select-tags>
